
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/hackathon2021",
      function () {
        return require("private-next-pages/events/hackathon2021/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/hackathon2021"])
      });
    }
  